import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import { useCustomerValue } from "providers/CustomerContext";
import { useState } from "react";
import { getSKUCategoryOptions } from "services/data.internal.service";
import { getUserOptions } from "services/data.internal.service";
import BasicTabs from "ui-components/tabs/BasicTabs";
import Assign from "./assign";
import Exception from "./exception";
import Pickslip from "./pickslip";
import PickslipLocation from "./pickslip-location";
import AllocationQueue from "./allocation-queue";
import { Checkbox } from "@mui/material";
import { ListLayout } from "ui-components/Layout";
import Demo2 from "./demo2";
import SOLog from "layouts/views/outbound/sales-order/components/SOLog";
import { getTAFilterOptions } from "services/data.outbound.service";
import { CheckboxHeader, CheckboxCell } from "ui-components/tables/components/table";
import PickslipAmend from "layouts/views/outbound/pickslip/pickslip-amend";

// const tabs = [
//   "Assign",
//   "Pickslip (Location)",
//   "Allocation Queue",
//   "Exception",
//   "Pickslip",
//   "Amend Pickslip",
// ];

function TaskAssignmentList() {
  const [status, setStatus] = useState("Assign");
  const { customerCode } = useCustomerValue();
  const tabs = [
    "Assign",
    "Pickslip (Location)",
    "Allocation Queue",
    "Exception",
    "Pickslip",
    ...(customerCode === "HOPPI" ||
    customerCode === "POLYMATERIA" ||
    customerCode === "RPG MONTIGO MY" ||
    customerCode === "RPG DISTRIBUTION" ||
    customerCode === "MONTIGO_SB" ||
    customerCode === "SG-MONTIGO" ||
    customerCode === "LUCKYMAXX" ||
    customerCode === "XHSYNAGIE" ||
    customerCode === "SARTORIUS" ||
    customerCode === "MIMPI KITA" ||
    customerCode === "SLEX TRADE MY"
      ? ["Amend Pickslip"]
      : []),
  ];

  const [userOptions, setUserOptions] = useState([]);
  const [szOptions, setSZOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [salesOptions, setSalesOptions] = useState([]);
  const [ptOptions, setPTOptions] = useState([]);

  const [list, setList] = useState([]);
  const [alert, setAlert] = useState(null);

  const [logRequest, setLogRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const logProp = { open, setOpen, logRequest, setLogRequest };

  const columns = [
    {
      id: "select",
      cell: CheckboxCell,
    },
    {
      accessorKey: "orderDate",
      header: "Order Date",
      width: 150,
    },
    {
      accessorKey: "custOrdNbr",
      header: "Cust Order Number",
      width: 150,
      cell: ({ row }) => {
        const { custOrdNbr, priority } = row.original;
        return (
          <span
            style={{
              color: priority ? "magenta" : "black",
              fontWeight: priority ? "bold" : 400,
            }}
          >
            {custOrdNbr}
          </span>
        );
      },
    },
    {
      accessorKey: "referenceNo",
      header: "Reference No",
      width: 150,
    },
    {
      accessorKey: "category",
      header: "Category",
      width: 200,
    },
    {
      accessorKey: "marketplace",
      header: "Marketplace",
      width: 100,
    },
    {
      accessorKey: "shippingZone",
      header: "Shipping Zone",
      width: 150,
    },
    {
      accessorKey: "group",
      header: "Group",
      width: 100,
      filterFn: "equalsString",
    },
    {
      accessorKey: "orderNumber",
      header: "Order Number",
      width: 150,
      cell: ({ row }) => {
        const { id, orderNumber } = row.original;
        return (
          <span
            style={{
              color: "#1A73E8",
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              setOpen(true);
              setLogRequest({ orderId: id, orderNumber, customerCode });
            }}
          >
            {orderNumber}
          </span>
        );
      },
    },
    {
      accessorKey: "remark",
      header: "Remark",
    },
  ];

  useQuery({
    queryKey: ["user-options", { customerCode }],
    queryFn: () => getUserOptions({ customerCode }),
    onSuccess: (data) => setUserOptions(data.data.data),
    enabled: Boolean(customerCode),
  });

  useQuery({
    queryKey: ["filter-options", { customerCode }],
    queryFn: () => getTAFilterOptions({ customerCode }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      const { shippingZone, sales, priorityTag } = data.data.data;
      setSZOptions(shippingZone);
      setSalesOptions(sales);
      setPTOptions(priorityTag);
    },
  });
  useQuery({
    queryKey: ["category-options", { customerCode }],
    queryFn: () => getSKUCategoryOptions({ customerCode }),
    onSuccess: (data) => setCategoryOptions(data.data.data),
    enabled: Boolean(customerCode),
  });

  const render = () => {
    let task;
    switch (status) {
      case "Assign":
        task = (
          <Assign
            columns={columns}
            customerCode={customerCode}
            userOptions={userOptions}
            szOptions={szOptions}
            categoryOptions={categoryOptions}
            salesOptions={salesOptions}
            ptOptions={ptOptions}
            list={list}
            setList={setList}
            setAlert={setAlert}
          />
        );
        break;

      case "Exception":
        task = <Exception customerCode={customerCode} />;
        break;
      case "Pickslip":
        task = <Pickslip customerCode={customerCode} setAlert={setAlert} />;
        break;
      case "Pickslip (Location)":
        task = (
          <PickslipLocation
            customerCode={customerCode}
            userOptions={userOptions}
            setAlert={setAlert}
          />
        );
        break;
      case "Allocation Queue":
        task = <AllocationQueue customerCode={customerCode} />;
        break;
      case "Amend Pickslip":
        if (
          customerCode === "HOPPI" ||
          customerCode === "POLYMATERIA" ||
          customerCode === "RPG MONTIGO MY" ||
          customerCode === "RPG DISTRIBUTION" ||
          customerCode === "MONTIGO_SB" ||
          customerCode === "SG-MONTIGO" ||
          customerCode === "LUCKYMAXX" ||
          customerCode === "XHSYNAGIE" ||
          customerCode === "SARTORIUS" ||
          customerCode === "MIMPI KITA" ||
          customerCode === "SLEX TRADE MY"
        )
          task = <PickslipAmend customerCode={customerCode} />;
        else task = null;
        break;
    }

    return task;
  };
  return (
    <ListLayout lg={12}>
      <SOLog {...logProp} />
      <MDBox my={3}>
        {alert}
        <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />

        <MDBox>{render()}</MDBox>
      </MDBox>
    </ListLayout>
  );
}

export default TaskAssignmentList;
